<script>
import AgentPerformanceReports from './AgentPerformanceReports.vue';
import AgentsInboxesReports from './AgentsInboxesReports.vue';
import AgentComparisonReports from './AgentComparisonReports.vue';

export default {
  components: {
    AgentPerformanceReports,
    AgentsInboxesReports,
    AgentComparisonReports,
  },
  data() {
    return {
      selectedTabIndex: 0,
      showAgentPerformance: false,
      selectedAgent: null,
    };
  },
  computed: {
    tabs() {
      return [
        {
          key: 'comparison',
          name: this.$t('AGENT_REPORTS.TABS.COMPARISON'),
        },
        {
          key: 'agents_inboxes',
          name: this.$t('AGENTS_INBOXES_REPORTS.HEADER'),
        },
      ];
    },
  },
  methods: {
    onTabChange(index) {
      this.selectedTabIndex = index;
      this.showAgentPerformance = false;
    },
    onAgentSelect(agent) {
      this.selectedAgent = agent;
      this.showAgentPerformance = true;
    },
    onBackToComparison() {
      this.selectedAgent = null;
      this.selectedTabIndex = 0;
      this.showAgentPerformance = false;
    },
  },
};
</script>

<template>
  <div class="flex flex-col flex-1 min-h-0">
    <woot-tabs
      class="font-medium [&_.tabs]:p-0 px-4 pt-4"
      :index="selectedTabIndex"
      @change="onTabChange"
    >
      <woot-tabs-item
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :index="index"
        :name="tab.name"
        :show-badge="false"
      />
    </woot-tabs>

    <AgentComparisonReports
      v-if="!showAgentPerformance && selectedTabIndex === 0"
      @agent-select="onAgentSelect"
    />

    <div v-else-if="showAgentPerformance" class="flex flex-col flex-1 min-h-0">
      <div class="px-4 pt-4">
        <button
          type="button"
          class="flex items-center p-0 text-sm font-normal cursor-pointer text-n-slate-11 hover:text-n-slate-12"
          @click="onBackToComparison"
        >
          <i class="-ml-1 text-lg i-lucide-chevron-left" />
          {{ $t('AGENT_REPORTS.COMPARISON.BACK') }}
        </button>
      </div>
      <AgentPerformanceReports
        :key="`agent-reports-${selectedAgent.id}`"
        :selected-item="selectedAgent"
      />
    </div>

    <AgentsInboxesReports v-else />
  </div>
</template>
